/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddressAddItem, IAddressAddUpdateProps } from '@msdyn365-commerce-modules/address/src/modules/checkout-shipping-address/../../common/components/address-add';
import { IAddressSelectItem, IAddressSelectProps } from '@msdyn365-commerce-modules/address/src/modules/checkout-shipping-address/../../common/components/address-select';
import { IAddressShowItem, IAddressShowProps } from '@msdyn365-commerce-modules/address/src/modules/checkout-shipping-address/../../common/components/address-show';
import { ICheckoutShippingAddressViewProps } from '@msdyn365-commerce-modules/address/src/modules/checkout-shipping-address/./checkout-shipping-address';

const AddressShow: React.FC<IAddressShowProps> = ({
    AddressDetail,
    items
}) => {
    return (
        <Node {...AddressDetail}>
            {items && items.map((item: IAddressShowItem) => {
                return (
                    <>
                        {item.description}
                    </>
                );
            })}
        </Node>
    );
};

const AddressSelect: React.FC<IAddressSelectProps> = ({
    SelectAddress,
    addButton,
    items,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton
}) => {

    return (
        <Node {...SelectAddress}>
            {addButton}
            {items && items.map((item: IAddressSelectItem) => {
                const SelectItem = item.SelectItem;
                return (<Node {...SelectItem} key={item.key}>
                    {item.input}
                    <AddressShow {...item.showItems} />
                </Node>);
            })}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const sortArray = (arr1: any[], arr2: any[]) => {
    arr2.sort((a, b) => {
       const aKey = a.key;
       const bKey = b.key;
       return arr1.indexOf(aKey) - arr1.indexOf(bKey);
    });
 };

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = ({
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
    //@ts-ignore
    countriesList,
    //@ts-ignore
    fieldsToHide
}) => {
    // re-order the address...
    const order = ["Name", "ThreeLetterISORegionName", "StreetNumber", "Street", "DistrictName", "City", "State", "ZipCode", "BuildingCompliment", "Phone"]
    sortArray(order, items);
    //fieldsToHide
    let country: any = items.find(item => item.key === 'ThreeLetterISORegionName');

    if (countriesList && countriesList.length && country && country.input && country.input.props.displayData) {
        let res = country.input.props.displayData.filter((countryData: any) => countriesList.indexOf(countryData.key) !== -1)
        country.input.props.displayData = res;
    }

    return (
        <Node {...AddressForm}>
            {heading}
            {items && items.map((item: IAddressAddItem) => {
                if (item.key !== "StreetNumber") {
                    const { AddressItem, key, label, alert, input } = item;
                    return (<Node {...AddressItem} key={key}>
                        {label}
                        {alert}
                        {input}
                    </Node>);
                }
                return null;
            })}
            {hasError && <Node {...error.AddressError}>
                {error.title}
                {error.message}
            </Node>}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const CheckoutShippingAddressView: React.FC<ICheckoutShippingAddressViewProps> = props => {
    const { CheckoutShippingAddress, viewState, showAddress, showAddressSelect, showAddOrUpdateAddress, cartLineImages } = props;
    /* @ts-ignore */
    const { countriesList, fieldsToHide } = props.config;

    return (
        <Module {...CheckoutShippingAddress}>
            {cartLineImages}
            {viewState.isShowAddress && <AddressShow {...showAddress} />}
            {viewState.isShowAddresList && <AddressSelect {...showAddressSelect} />}
            {/* @ts-ignore */}
            {viewState.isShowAddOrUpdateAddress && <AddressAddUpdate {...showAddOrUpdateAddress} countriesList={countriesList} fieldsToHide={fieldsToHide}/>}
        </Module>
    );
};

export default CheckoutShippingAddressView;
